export enum RowAction {
    SEE_DETAILS = 'SEE_DETAILS',
    EDIT = 'EDIT',
    DELETE = 'DELETE',
}
